var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-redio",on:{"click":_vm.handClick}},[(_vm.value)?_c('svg-icon',{attrs:{"class-name":"icon-16","icon-class":"radio-checked"}}):_c('svg-icon',{attrs:{"class-name":"icon-16","icon-class":"radio-uncheck"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }